/**
 * Composable для работы со справочниками
 * Удобная обертка над references store
 *
 * DEV-42: clientStatuses упразднён вместе со справочником.
 */
import { storeToRefs } from 'pinia'
import { useReferencesStore } from '../stores/references.store'

export const useReferences = () => {
  const referencesStore = useReferencesStore()

  // Reactive refs from store
  const {
    leadSources,
    countries,
    archiveReasons,
    clientTags,
    isLoading,
    isLoaded,
    error,
    activeLeadSources,
    allCountries,
  } = storeToRefs(referencesStore)

  // Actions
  const {
    loadAll,
    reload,
    getArchiveReasonByKey,
    getLeadSourceById,
    getLeadSourceByKey,
    getCountryById,
    getCountryByIsoCode,
  } = referencesStore

  return {
    // State
    leadSources,
    countries,
    // DEV-1061/DEV-1062: причины архивации и теги клиента.
    archiveReasons,
    clientTags,
    isLoading,
    isLoaded,
    error,

    // Computed
    activeLeadSources,
    allCountries,

    // Actions
    loadAll,
    reload,
    getArchiveReasonByKey,
    getLeadSourceById,
    getLeadSourceByKey,
    getCountryById,
    getCountryByIsoCode,
  }
}
